import { API_URL } from '../../config';
import { CALL_API } from '../../middlewares/apiMiddleware';
import { 
  PENDING, FULFILLED, REJECTED,
  STATS__MODAL_STATS__TOGGLE,
  STATS__MODAL_STATS__GET_OFFICES,
  STATS__MODAL_STATS__SELECT_OFFICE,
  STATS__MODAL_STATS__GET_STATS,
} from '../../globals';


/**
 * Modal Stats - Toggle
 */
export function toggleStatsModal(defaultOffice = null) {
  return {
    type: `${STATS__MODAL_STATS__TOGGLE}`,
    payload: {
      defaultOffice,
    },
  };
}


/**
 * Modal Stats - Select Office
 */
export function selectOffice(office) {
  return {
    type: `${STATS__MODAL_STATS__SELECT_OFFICE}`,
    payload: {
      office,
    },
  };
}


/**
 * Get Offices DropDown data
 */
export function getOfficesDDRequest(){
  return {
    type: `${STATS__MODAL_STATS__GET_OFFICES}_${PENDING}`,
  };
}

export function getOfficesDDSuccess(response){
  return {
    type: `${STATS__MODAL_STATS__GET_OFFICES}_${FULFILLED}`,
    payload: {
      data: response.data,
      status: response.status,
    }
  };
}

export function getOfficesDDFailure(response){
  return {
    type: `${STATS__MODAL_STATS__GET_OFFICES}_${REJECTED}`,
    payload: {
      errorMessage: response,
    }
  };
}


export const getOfficesDD = () => ({
  [CALL_API]: {
    actions: [getOfficesDDRequest, getOfficesDDSuccess, getOfficesDDFailure],
    url: `${API_URL}/web/stores`,
  },
});


/**
 * Get Stats for Office
 */
export function getStatsRequest(){
  return {
    type: `${STATS__MODAL_STATS__GET_STATS}_${PENDING}`,
  };
}

export function getStatsSuccess(response){
  return {
    type: `${STATS__MODAL_STATS__GET_STATS}_${FULFILLED}`,
    payload: {
      data: response.data,
      status: response.status,
    }
  };
}

export function getStatsFailure(response){
  return {
    type: `${STATS__MODAL_STATS__GET_STATS}_${REJECTED}`,
    payload: {
      errorMessage: response,
    }
  };
}


export const getStats = (officeId) => ({
  [CALL_API]: {
    actions: [getStatsRequest, getStatsSuccess, getStatsFailure],
    url: `${API_URL}/web/stat?store_id=${officeId}`,
  },
});



// WEBPACK FOOTER //
// ./src/components/Stats/actions.js